
export default {


        getMenu(id_perfil, nome_perfil ) {

                if (nome_perfil != null && (id_perfil == 3  || nome_perfil.toString().toLowerCase()  == "cliente") ) { // id_perfil.toString() == "31"
                        //Perfil de Cliente.
                        return [
                                {
                                        path: "/area",
                                        name: "DashBoard",
                                        icon: "dashboard"
                                },

                                {
                                        path: "/area/auditoria",
                                        name: "Auditoria Técnica",
                                        icon: "assignment"
                                },

                                {
                                        path: "/area/cliente_oculto",
                                        name: "",
                                        icon: "supervisor_account"
                                },
                                {
                                        path: "/area/visita",
                                        name: "Diagnóstico e plano de ação",
                                        icon: "file_copy"
                                },

                                {
                                        path: "/area/validade",
                                        name: "Laudos",
                                        icon: "today"
                                },
                                {
                                        path: "/area/documentos",
                                        name: "Plano de capacitação",
                                        icon: "attach_file"
                                },
                                {
                                        path: "/area/grafico",
                                        name: "Gráficos",
                                        icon: "bar_chart"
                                },

                        ];


                }

                let menu_completo = this.getMenuCompleto();

                if (id_perfil.toString() == "1") {
                        return menu_completo; //Administrador tem o menu completo..
                }

                let user = JSON.parse(window.obj_user.getUser());

                let menu_perfil = [];

                if (user.menus != null) {

                        for (var i = 0; i < menu_completo.length; i++) {
                                let item_menu = menu_completo[i];

                                if (this.hasMenuPai(id_perfil.toString(), user.menus, item_menu.codigo)) {

                                        var tmp_pai = JSON.parse(JSON.stringify(item_menu));
                                        tmp_pai.children = [];

                                        for (var z = 0; z < item_menu.children.length; z++) {
                                                if (this.hasMenuFilho(id_perfil.toString(), user.menus, item_menu.codigo, item_menu.children[z].codigo)) {

                                                        tmp_pai.children.push(JSON.parse(JSON.stringify(item_menu.children[z])));
                                                }

                                        }

                                        menu_perfil.push(tmp_pai);

                                }
                        }

                }

                return menu_perfil;




        },

        getMenuCompleto() {
                return [

                        {
                                path: "/operacional",
                                name: "Operacional",
                                icon: "build",
                                codigo: "SOC",

                                children: [
                                        {
                                                path: "dashboard",
                                                name: "Dashboard",
                                                icon: "dashboard",
                                                codigo: "dashboard",
                                        },

                                        {
                                                path: "graficos",
                                                name: "Gráficos",
                                                icon: "bar_chart",
                                                codigo: "graf_unidades",
                                        },
                                        {
                                                path: "auditoria",
                                                name: "Auditoria Técnica",
                                                icon: "ballot",
                                                codigo: "inspecao",
                                        },
                                        {
                                                path: "visita",
                                                name: "Diagnóstico e plano de ação",
                                                icon: "file_copy",
                                                codigo: "relatorio_visita",
                                        },

                                        {
                                                path: "validade",
                                                name: "Laudos",
                                                icon: "today",
                                                codigo: "relatorio_produtos",
                                        },
                                        {
                                                path: "documentos",
                                                name: "Plano de capacitação",
                                                icon: "attach_file",
                                                codigo: "documento",
                                        },

                                ]
                        },

                        {
                                path: "/modelos",
                                name: "Modelos",
                                icon: "spellcheck",
                                codigo: "ModModelo",

                                children: [{
                                        path: "checklist",
                                        name: "CheckList",
                                        icon: "spellcheck",
                                        codigo: "modelo_checklist",
                                },
                                {
                                        path: "categorias",
                                        name: "Categorias",
                                        icon: "category",
                                        codigo: "categoria_checklist",
                                },
                                {
                                        path: "itens",
                                        name: "Itens do Checklist",
                                        icon: "playlist_add_check",
                                        codigo: "itens_checklist",
                                }]

                        },

                        {
                                path: "/cliente",
                                name: "Clientes / Unidades",
                                icon: "people",
                                codigo: "ModCli",
                                children: [
                                        {
                                                path: "cadastro",
                                                name: "Cliente",
                                                icon: "person",
                                                codigo: "cliente",
                                        },
                                        {
                                                path: "unidade",
                                                name: "Unidades",
                                                icon: "store",
                                                codigo: "estabelecimento",
                                        }

                                ]
                        },

                        {
                                path: "/admin",
                                name: "Admin",
                                icon: "settings",
                                codigo: "ModAdmin",
                                children: [
                                        {
                                                path: "usuarios",
                                                name: "Usuários",
                                                icon: "people",
                                                codigo: "usuario",
                                        },
                                        {
                                                path: "profissionais",
                                                name: "Profissionais",
                                                icon: "person_pin",
                                                codigo: "profissional",
                                        },
                                        {
                                                path: "pesos",
                                                name: "Pesos",
                                                icon: "tune",
                                                codigo: "pesos",
                                        },
                                        {
                                                path: "perfil_acesso",
                                                name: "Perfil de Acesso",
                                                icon: "supervisor_account",
                                                codigo: "perfil_acesso",
                                        },
                                        {
                                                path: "funcoes",
                                                name: "Funções",
                                                icon: "recent_actors",
                                                codigo: "cad_4",
                                        },

                                ]
                        }

                ];
        },


        hasMenuPai(cod_perfil, menus, codigo) {

                if (cod_perfil.toString() == "1")
                        return true;

                if (menus[codigo] != null && menus[codigo] != undefined) {
                        return true;
                }


                return false;

        },

        hasMenuFilho(cod_perfil, menus, codigo_pai, codigo_filho) {

                if (cod_perfil.toString() == "1")
                        return true;

                let menu_filho = menus[codigo_pai];
                let itens = menu_filho.itens;

                return itens.indexOf(codigo_filho) > -1;


        },




}